import React, { useMemo } from "react";
import { useParams } from "react-router-dom";
import useRemoteReviews from "../../../../../hooks/queryResults/remote/useRemoteReviews";
import Table from "../../../../layout/Table";
import Loading from "../../../../ui/Loading";
import AdminRemoteReviewButton from "../../reviews/AdminRemoteReviewButton";

export default function AdminRemoteReviewsNflPlayer() {
  const finalDocType = "NflPlayer";
  const { reviews, remoteReviewsQuery } = useRemoteReviews(finalDocType);
  const { review: reviewId } = useParams();

  console.log("reviewId", reviewId);

  const review = !!reviews
    ? reviews.filter((review) => review.id === reviewId)[0]
    : null;

  console.log("review", review);

  const columns = useMemo(
    () => [
      { Header: "Site", accessor: "remoteSiteAbbr" },
      { Header: "Id", accessor: "remoteId" },
      { Header: "Pos", accessor: "pos" },
      { Header: "First", accessor: "firstName", className: "left" },
      { Header: "Last", accessor: "lastName", className: "left" },
      { Header: "Team", accessor: "remoteNflFranchiseAbbr" },
      { Header: "Jersey", accessor: "jerseyNum" },
      { Header: "Height", accessor: "height" },
      { Header: "Weight", accessor: "weight" },
      { Header: "Exp", accessor: "experience" },
      { Header: "Add", accessor: "add" },
      { Header: "Skip", accessor: "skip" },
    ],
    []
  );

  const data = useMemo(() => {
    const data = [];
    if (!review) return data;
    const doc = review.focusDoc;
    return [
      {
        remoteSiteAbbr: doc.remoteSiteAbbr,
        remoteId: doc.remoteId,
        pos: doc.pos,
        firstName: doc.firstName,
        lastName: doc.lastName,
        remoteNflFranchiseAbbr: doc.remoteNflFranchiseAbbr,
        jerseyNum: doc.jerseyNum,
        height: doc.height,
        weight: doc.weight,
        experience: doc.experience,
        add: (
          <AdminRemoteReviewButton
            finalDocType={finalDocType}
            action={"add"}
            review={review}
          />
        ),
        skip: (
          <AdminRemoteReviewButton
            finalDocType={finalDocType}
            action={"skip"}
            review={review}
          />
        ),
      },
    ];
  }, [review]);

  const finalDocColumns = useMemo(
    () => [
      { Header: "ESPN", accessor: "espnId" },
      { Header: "CBS", accessor: "cbsId" },
      { Header: "PFR", accessor: "pfrId" },
      { Header: "FP", accessor: "fpId" },
      { Header: "Pos", accessor: "pos" },
      { Header: "First", accessor: "firstName", className: "left" },
      { Header: "Last", accessor: "lastName", className: "left" },
      { Header: "Team", accessor: "nflFranchiseAbbr" },
      { Header: "Jersey", accessor: "jerseyNum" },
      { Header: "Height", accessor: "height" },
      { Header: "Weight", accessor: "weight" },
      { Header: "Exp", accessor: "experience" },
      { Header: "Connect", accessor: "connect" },
    ],
    []
  );

  const finalDocData = useMemo(() => {
    if (!review) return [];

    return review?.finalDocs.map((doc) => ({
      espnId: doc.espnId,
      cbsId: doc.cbsId,
      pfrId: doc.pfrId,
      fpId: doc.fpId,
      pos: doc.pos,
      firstName: doc.firstName,
      lastName: doc.lastName,
      nflFranchiseAbbr: doc.nflFranchiseAbbr,
      jerseyNum: doc.jerseyNum,
      height: doc.height,
      weight: doc.weight,
      experience: doc.experience,
      connect: (
        <AdminRemoteReviewButton
          finalDocType={finalDocType}
          review={review}
          action={"update"}
          data={{ finalDocToConnectUrlId: doc.id }}
        />
      ),
    }));
  }, [review]);

  if (remoteReviewsQuery.isLoading) return <Loading />;

  return (
    <>
      <h1>Review</h1>
      <Table columns={columns} data={data} />
      {review?.finalDocs.length ? (
        <>
          <h1>Final Docs</h1>
          <Table columns={finalDocColumns} data={finalDocData} />
        </>
      ) : null}
    </>
  );
}
